<!--
@创建人: lfq
@联系Qq:1638245306
@创建时间: 2020-06-22 15:21:56
@文件介绍: 国家桥梁导入
-->
<template>
    <div style="display:inline-block;padding:0px 10px;">
        <el-dialog
                title="导入"
                :visible.sync="fileShow"
                @close="$emit('update:dialogShow', false)"
                :show-close="false" :append-to-body="true" :close-on-click-modal="false"
                width="45%">
            <!-- <p style="font-size:16px;">1. 国家桥梁系统数据导出方式:左侧菜单=>桥梁综合查询=>选择列=>全选所有列(基础识别、结构数据、经济指标、桥梁档案、桥梁桥牌)=>导出报表</p> -->
            <p style="font-size:16px;">1. 国家桥梁系统数据导出方式:左侧菜单=>桥梁综合查询=>选择列=>全选所有列=>导出报表</p>
            <p style="font-size:16px;">2. 若需修改导出内容,则手动修改内容(不允许修改列信息),另存为"xlsx"文件</p>

            <p style="font-size:16px;">3. 请选择或拖拽需要导入的[国家桥梁"xlsx"]文件</p>
            <p style="font-size:16px;">4.  若系统内不存在国家桥梁数据,则自动新增;若系统内存在国家桥梁数据(桥梁编码),则直接更新</p>

            <el-upload
                    :ref='refName'
                    :headers="myHeaders"
                    :action="importUrl"
                    drag
                    :auto-upload="true"
                    :file-list="fileList"
                    :on-success='successHandle'
                    :on-error="errorHandle"
                    multiple
            >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
            <div slot="footer">
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import util from '@/libs/util.js'
    export default {
        data() {
            return {
                refName:'',
                imgVisible:false,
                fileList:[],
                dialogImageUrl: '',
                fileShow:this.dialogShow,
                btnLoading:false,
                myHeaders:{

                }
            };
        },
        props:{
            dialogShow:{
                type:Boolean,
                default:false
            },
            importUrl:{
                type:String
            },
            exportFile:{
                type:String
            }
        },
        watch:{
            dialogShow(val, oldVal) {
                if (val === oldVal) {
                    return
                }
                this.fileShow = val
            }
        },
        methods: {
            uploadFile(){

            },
            //成功后的回调
            successHandle(response, file, fileList){
                this.fileShow = false
                let res={};
                if(Array.isArray(fileList)){
                    res=fileList[0].response;
                }else{
                    res=fileList.response;
                }
                let msg = res.resultMsg;
                if(res.resultCode===2000){
                    this.$message.success("导入成功")
                    this.$router.push('refresh')
                }else if(res.resultCode===9001){
                    this.$message.error(res.resultMsg)
                    this.fileList = []
                }else{
                    this.$message.error(msg)
                    this.fileList = []
                }

                this.cancel();
            },
            //失败后的回调
            errorHandle(response, file, fileList){
                this.fileList = []
            },
            handleRemove(file, fileList) {
            },
            cancel(){
                this.fileShow=false;
                this.$emit('cancel');
            },
            /**模板下载 */
            downloadFile(){
                let that = this
                that.btnLoading = true
                setTimeout(function(){
                    that.btnLoading = false
                },"2000");
                window.open(this.$url.downLoadFile + '?exportType=' + this.exportFile,'_blank')
            },
            getUserToken(){
                let token = util.session.get("token")
                this.myHeaders = {
                    userToken:token
                }
            }
        },
        created(){
            this.refName = 'uploadFile' + new Date().getTime()
        },
        mounted() {
            this.getUserToken()
        }
    }
</script>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Customize/UploadBrige.vue"
}
</vue-filename-injector>
